import { allPass, defaultTo, equals, hasPath, path, pathSatisfies, pipe } from 'ramda'
import { clientFactory } from 'mage-core'
import { createSelector } from 'reselect'
import { NAME } from './constants'

export const educationFeatures = path([NAME, 'features'])
export const isAuthenticatedFeaturesLoaded = path([NAME, 'isAuthenticatedFeaturesLoaded'])

export const merchantEducationEvents = path([NAME, 'events'])
export const merchantEducationEventsPending = path([NAME, 'eventsPending'])

export const educationClient = createSelector(clientFactory, factory => factory('/api/education'))

export const testEducationFeaturePropEqualities = (featureName, propEqualities) => {
  const tests = Object.entries(propEqualities).map(([key, value]) =>
    pathSatisfies(equals(value), [featureName, key])
  )

  return createSelector(educationFeatures, allPass(tests))
}

export const isEducationFeatureToggleEnabled = featureName =>
  createSelector(educationFeatures, pipe(defaultTo({}), hasPath([featureName, 'is_enabled'])))
